'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/20.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopsMap = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ExperienceShopsMap, _Component);

  function ExperienceShopsMap() {
    (0, _classCallCheck3.default)(this, ExperienceShopsMap);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopsMap).call(this));
  }

  (0, _createClass3.default)(ExperienceShopsMap, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var carouselDiv = '';
      if (data) {
        var carouselOfExperienceShopMap = data.carouselOfExperienceShopMap;
        var carouselOfExperienceShopMapError = data.carouselOfExperienceShopMapError;

        if (carouselOfExperienceShopMapError) {
          carouselDiv = _react2.default.createElement(_components.ErrorLabel, { error: carouselOfExperienceShopMapError });
        } else if (carouselOfExperienceShopMap instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: carouselOfExperienceShopMap });
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ExperienceShopsMapComponent, null),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ExperienceShopsMap;
}(_react.Component), _class.propTypes = {
  location: _react.PropTypes.object,
  dataError: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object
}, _temp);
exports.default = ExperienceShopsMap;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopsMap/ExperienceShopsMap.js
 ** module id = 1483
 ** module chunks = 0
 **/